var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversalType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 61,
    viewBox: "0 0 66 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.3461,
    height: 61,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7975 23.1021L23.8465 23.1021C24.4741 23.1276 24.9703 23.6406 24.9703 24.2649L24.9703 40.8525C24.9703 41.4921 24.4479 42.0162 23.7975 42.0162C23.1471 42.0162 22.6247 41.4921 22.6247 40.8525L22.6247 24.2659C22.6247 23.6255 23.1469 23.1021 23.7975 23.1021Z",
    stroke: "#0D4248",
    strokeWidth: 1.17261
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3424 23.1021L43.3914 23.1021C44.019 23.1276 44.5153 23.6406 44.5153 24.2649L44.5153 40.8525C44.5153 41.4921 43.9928 42.0162 43.3424 42.0162C42.6921 42.0162 42.1696 41.4921 42.1696 40.8525L42.1696 24.2659C42.1696 23.6255 42.6919 23.1021 43.3424 23.1021Z",
    stroke: "#0D4248",
    strokeWidth: 1.17261
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1179 21.7993L30.1708 21.7993C30.8535 21.8308 31.486 22.468 31.486 23.3684L31.486 43.8101C31.486 44.7328 30.8202 45.3805 30.1179 45.3805C29.4156 45.3805 28.7499 44.7328 28.7499 43.8101L28.7499 23.3696C28.7499 22.446 29.4154 21.7993 30.1179 21.7993Z",
    stroke: "#0D4248",
    strokeWidth: 1.17261
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6316 16.5881L36.6818 16.5881C37.3198 16.6224 37.9996 17.3048 37.9996 18.3842L37.9996 40.9777C37.9996 42.0843 37.2834 42.775 36.6316 42.775C35.9798 42.775 35.2635 42.0843 35.2635 40.9777L35.2635 18.3855C35.2635 17.2778 35.9796 16.5881 36.6316 16.5881Z",
    stroke: "#0D4248",
    strokeWidth: 1.17261
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4336 35.543L46.7944 35.543",
    stroke: "#0D4248",
    strokeWidth: 1.3029,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversalType1);
export default __webpack_public_path__ + "static/media/universal-type1.15f79cb52f1dffbab924b1ed65f384c2.svg";
export { ForwardRef as ReactComponent };